import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { CardBlogComponent } from './card-blog/card-blog.component';
import { GeneralesComponentsModule } from '../../generales/components/components.module';
import { ExchangeComponent } from './exchange/exchange.component';
import { SegmentAdminComponent } from './segment-admin/segment-admin.component';
import { ModalShopsComponent } from './modal-shops/modal-shops.component';
import { EditCategorieComponent } from './edit-categorie/edit-categorie.component';
import { ModalPublicityComponent } from './modal-publicity/modal-publicity.component';
import { CategoriesComponent } from './categories/categories.component';
import { CertificateComponent } from './certificate/certificate.component';
import { PaymentsComponent } from './payments/payments.component';
import { ShopsComponent } from './shops/shops.component';
import { CardItemsAdminComponent } from './card-items-admin/card-items-admin.component';
import { TranslateModule } from '@ngx-translate/core';
import { CreateCurrencyComponent } from './create-currency/create-currency.component';
import { AccountBanksComponent } from './account-banks/account-banks.component';
import { CreateBankComponent } from './create-bank/create-bank.component';
import { HeaderAdminComponent } from './header-admin/header-admin.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { UsersComponent } from './users/users.component';
import { BalanceComponent } from './balance/balance.component';
import { ProductsComponent } from './products/products.component';
import { CitiesComponent } from './cities/cities.component';
import { LocationComponent } from './location/location.component';
import { UploadImgComponent } from './upload-img/upload-img.component';
import { MetricsComponent } from './metrics/metrics.component';
import { MetricSatsComponent } from './metric-sats/metric-sats.component';
import { TermsComponent } from './terms/terms.component';
import { EditerComponent } from './editer/editer.component';
import { ProductStatsComponent } from './product-stats/product-stats.component';
import { ProductStatsCardComponent } from './product-stats-card/product-stats-card.component';
import { PipesModule } from '../pipes/pipes.module';
import { ReviewComponent } from './review/review.component';
import { ProducttChartComponent } from './productt-chart/productt-chart.component';
import { ReviewStatItemComponent } from './review-stat-item/review-stat-item.component';
import { FilterProductComponent } from './filter-product/filter-product.component';
import { StoreStatsComponent } from './store-stats/store-stats.component';
import { LoadComponent } from './load/load.component';
import { LoadExcelComponent } from './load-excel/load-excel.component';
import { TrialPricesComponent } from './trial-prices/trial-prices.component';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { CKEditorModule } from 'ckeditor4-angular';
import { PaypalComponent } from './paypal/paypal.component';
import { StripeComponent } from './stripe/stripe.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { StoresComponent } from './stores/stores.component';
import { PasarelaAdminComponent } from './pasarela-admin/pasarela-admin.component';
import { MultinivelComponent } from './multinivel/multinivel.component';
import { SharedModule } from 'src/app/directives/shared.module';
import { CreateMultinivelComponent } from './create-multinivel/create-multinivel.component';
import { GridManagementComponent } from './grid-management/grid-management.component';
import { StateAccountComponent } from './state-account/state-account.component';
import { StatsAmountComponent } from './stats-amount/stats-amount.component';
import { StatsSearchComponent } from './stats-search/stats-search.component';


const declarations = [
  ExchangeComponent,
  SegmentAdminComponent,
  ModalShopsComponent,
  EditCategorieComponent,
  ModalPublicityComponent,
  CategoriesComponent,
  CertificateComponent,
  PaymentsComponent,
  ShopsComponent,
  CardItemsAdminComponent,
  CreateCurrencyComponent,
  AccountBanksComponent,
  CreateBankComponent,
  HeaderAdminComponent,
  DashboardAdminComponent,
  UsersComponent,
  BalanceComponent,
  ProductsComponent,
  CitiesComponent,
  LocationComponent,
  UploadImgComponent,
  MetricsComponent,
  MetricSatsComponent,
  TermsComponent,
  EditerComponent,
  ProductStatsComponent,
  ProductStatsCardComponent,
  ReviewComponent,
  ProducttChartComponent,
  ReviewStatItemComponent,
  FilterProductComponent,
  StoreStatsComponent,
  LoadComponent,
  LoadExcelComponent,
  TrialPricesComponent,
  PaypalComponent,
  StripeComponent,
  StoresComponent,
  PasarelaAdminComponent,
  MultinivelComponent,
  CreateMultinivelComponent,
  GridManagementComponent,
  StateAccountComponent,
  StatsAmountComponent,
  StatsSearchComponent
]

@NgModule({
  declarations,
  imports: [
    CommonModule, 
    IonicModule, 
    FormsModule, 
    GeneralesComponentsModule, 
    TranslateModule,
    ReactiveFormsModule,
    PipesModule,
    CKEditorModule,
    NgxStarRatingModule,
    NgxPayPalModule,
    SharedModule
  ],
  exports: declarations,
})
export class ComponentsAdminModule {}
